import { IQueuePositionManager, ScrollDirection } from '../types.d';

export default class UpQpm implements IQueuePositionManager {
  direction = ScrollDirection.Up;
  isBefore: IQueuePositionManager['isBefore'] = (a, b) => a > b;
  getTrigger: IQueuePositionManager['getTrigger'] = (triggers) =>
    triggers === null ? null : triggers.up;
}
